import React, { useEffect, useState, useRef } from "react";
import { Stack, Button, Box, Divider } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";

import { LoadingButton } from "@mui/lab";

import Data from "../Components/Data.json";
import {
  KraUpdateAPICall,
  stageDetailsAPICall,
  startOverAPICall,
} from "../shared/APICalls";
import JsonDataToAadhaarFormat from "../Components/JsonDataToAadhaarFormat/JsonDataToAadhaarFormat";
import routesData from "../shared/routes.json";
import AadhaarStyles from "../pages/Styles/AadharKYC.module.scss";
import AadhaarImage from "../Components/assets/Images/aadhaarpagenewimage.svg";
import StageLayout from "../Layouts/StageLayout";
import icon from "../Components/assets/Images/iconnew.svg";
import SnackBar from "../Components/SnackBars/SnackBar";
import KRAScreen from "./KRAscreen";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { confirmAlert } from "react-confirm-alert";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "80vH",
  bgcolor: "white",

  padding: "10px 5px 10px 5px",
};

export default function AadhaarKYCPage() {
  const navigate = useNavigate();

  const [completedStages, setCompletedStages] = useState<any>();
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [closetTimer, setclosetTimer] = useState(false);
  const [loading, setloading] = useState(false);
  const [startOverloading, setstartOverloading] = useState(false);

  const [KraData, setKraData] = useState<any>({
    KraData: {},
    isAadhaarFetched: false,
  });
  const navigationData = routesData;
  const [navigatePath, setNavigate] = useState<any>();
  const [message, setMessage] = useState("");

  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");

  const timerRef = useRef<any>(null);

  const handleContinuetoNextPage = () => {
    let obj = {
      kra_continue: true,
    };
    KraUpdateAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error.response.data.message);
      });
    setloading(false);
  };

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
              });
          },
        },
      ],
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    let obj: any = {
      stage: "kra_details",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setCompletedStages(responseData.completed_stages);
        //  console.log(responseData);
        // console.log("response", response.data.data.StageDetails.KraStatus);
        setRejectMessage(response.data.data.StageDetails.ErrorMessage);
        if (response.data.data.StageDetails.KraDetails) {
          setKraData(response.data.data.StageDetails.KraDetails);
        }
      })
      .catch((error: any) => {});
  }, []);

  const handleUpdateAadhaarClick = () => {
    let obj = {
      kra_continue: false,
    };
    KraUpdateAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error.response.data.message);
      });
  };

  return (
    <div className={AadhaarStyles.mainWrapper}>
      <StageLayout
        completedStages={completedStages}
        stageName={"Fetched Details"}
        navigatePath={"/kra"}
      />

      <div className={AadhaarStyles.fetchWrapper}>
        <KRAScreen
          aadhaarData={KraData}
          aadaarFetched={KraData.isAadhaarFetched}
        />
        {backdrop && <StartOverBackDrop />}
        <div className={AadhaarStyles.fetchButtons}>
          <Button
            variant="outlined"
            className={AadhaarStyles.fetchUpdate}
            onClick={handleUpdateAadhaarClick}
          >
            Enter New Details
          </Button>
          <Button
            variant="contained"
            className={AadhaarStyles.fetchContinue}
            onClick={handleContinuetoNextPage}
          >
            Continue With Fetched
          </Button>
        </div>
        <div className={AadhaarStyles.startOverSection}>
          <img src={icon} className={AadhaarStyles.iconImage} />
          <p className={AadhaarStyles.paratext}>
            {" "}
            if the above mentioned info not yours
            <span
              className={AadhaarStyles.startoverbutton}
              onClick={handleStartOver}
            >
              Start Over
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
